import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

type Row = {
  id: string;
  created_at: string;
  profile: string | null;
  segment: string;
  score: number;
  signal_level: string | null;
  commitment_level: string | null;
  has_email: number | null;
};

export default function MagicResponses() {
  const { token } = useParams<{ token: string }>();
  const [rows, setRows] = useState<Row[]>([]);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    async function load() {
      if (!token) return;
      setErr(null);
      const res = await fetch(`/api/backoffice/magic/${encodeURIComponent(token)}/responses`);
      if (!res.ok) {
        setErr("No autorizado o link inválido.");
        return;
      }
      const data = (await res.json()) as { items: Row[] };
      setRows(data.items ?? []);
    }
    void load();
  }, [token]);

  if (err) return <p className="text-sm text-red-700">{err}</p>;
  if (!token) return null;
  const csvHref = `/api/backoffice/magic/${encodeURIComponent(token)}/responses?format=csv`;

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-pp-muted max-w-xl">
          Vista previa: hasta 200 filas. El CSV trae hasta 5000 respuestas de esta encuesta, con columnas clave y{" "}
          <span className="font-mono">answers_json</span> completo.
        </p>
        <a
          href={csvHref}
          className="inline-flex items-center justify-center rounded-lg border border-pp-border bg-pp-card px-4 py-2 text-sm font-medium text-pp-main shadow-sm hover:bg-pp-soft transition-colors shrink-0"
          download
        >
          Descargar CSV
        </a>
      </div>
      <section className="border rounded-lg bg-pp-card overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead className="bg-pp-soft">
          <tr>
            <th className="p-2 text-left">Fecha</th>
            <th className="p-2 text-left">Perfil</th>
            <th className="p-2 text-left">Segmento</th>
            <th className="p-2 text-left">Score</th>
            <th className="p-2 text-left">Señal</th>
            <th className="p-2 text-left">Compromiso</th>
            <th className="p-2 text-left">Email</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t">
              <td className="p-2">{r.created_at}</td>
              <td className="p-2">{r.profile ?? "—"}</td>
              <td className="p-2">{r.segment}</td>
              <td className="p-2">{r.score}</td>
              <td className="p-2">{r.signal_level ?? "—"}</td>
              <td className="p-2">{r.commitment_level ?? "—"}</td>
              <td className="p-2">{r.has_email === 1 ? "sí" : "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
    </div>
  );
}
